import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const EmailDetailsHeader = () => {
  return (
    <Grid
      container
      alignItems="center"
      gap="10px"
      sx={{
        color: "#3D4043",
        padding: "18px",
        borderBottom: "1px solid #E9E9E9",
      }}
    >
      <Box>
        <Typography
          sx={{
            color: "#3D4043",
          }}
        >
          Ticket Name
        </Typography>
      </Box>
      <Box>
        <Typography
          sx={{
            color: "#3D4043",
          }}
        >
          #2730776
        </Typography>
      </Box>
    </Grid>
  );
};
export default EmailDetailsHeader;
